import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
  Button,
  FormControlLabel,
  FormHelperText,
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Checkbox,
  RadioGroup,
  Radio,
  Chip,
  SvgIcon,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Divider,
  LinearProgress,
  Grid
} from "@material-ui/core";

import { CopyToClipboard } from "react-copy-to-clipboard";

import Alert from '@material-ui/lab/Alert';

import DescriptionIcon from '@material-ui/icons/Description';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";
import InfoTooltip from "../../general/InfoTooltip";
import { formatDate, formatDateTime } from '../../../functions/GlobalHelpers';
import FileUploadField from "../FileUploadField";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  addFieldsButton: {
    marginRight: 15
  }
}));

export default function CustomerPortalDialog(
  {
    personIndex,
    creditFunctions,
    createPortal,
    savePortal,
    portals,
    credit_id,
    metafields,
    setMetafields,
    renderAs = "dialog"
  }) {
  const theme = useTheme();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [isCreatingSignature, setIsCreatingSignature] = useState(false);
  const [requestSignatureDocument, setRequestSignatureDocument] = useState(false);
  /*
    {
      value: "human readable but escaped filename",
      kn1: bool,
      kn2: bool,
      kn3: bool,
      kn4: bool,
      common_document: bool,
      id: // setting id in case it is a global template
      key: "signature_template_1" //setting key in case it is a global template
      metafield_id: // in case it is a file uploaded for this credit
    }
  */
  const [hasAllRequiredFields, setHasAllRequiredFields] = useState(false);
  const [isWaitingForSave, setIsWaitingForSave] = useState(false);
  const [portalPin, setPortalPin] = useState("");
  const [isLoadingPortalPin, setIsLoadingPortalPin] = useState(false);
  const [signatures, setSignatures] = useState([]);
  const [signatureTemplates, setSignatureTemplates] = useState(
    {
      signature_template_1: {
        setting_type: "file",
        key: "signature_template_1",
      },
      signature_template_2: {
        setting_type: "file",
        key: "signature_template_2",
      },
      signature_template_3: {
        setting_type: "file",
        key: "signature_template_3",
      },
      signature_template_4: {
        setting_type: "file",
        key: "signature_template_4",
      },
      signature_template_5: {
        setting_type: "file",
        key: "signature_template_5",
      },
      signature_template_6: {
        setting_type: "file",
        key: "signature_template_6",
      },
      signature_template_7: {
        setting_type: "file",
        key: "signature_template_7",
      },
      signature_template_8: {
        setting_type: "file",
        key: "signature_template_8",
      },
      signature_template_9: {
        setting_type: "file",
        key: "signature_template_9",
      },
      signature_template_10: {
        setting_type: "file",
        key: "signature_template_10",
      }
    }
  );

  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);

  useEffect(() => {
    if (open) {
      setHasAllRequiredFields(
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__anrede") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__postleitzahl") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__ort") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__strasse") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__hausnummer") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__kontakt_mobil") &&
        creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__kontakt_email")
      );

      const newIsWaitingForSave = creditFunctions.isWaitingForSaveOfPortalField(personIndex, metafields);
      setIsWaitingForSave(newIsWaitingForSave);
      if (newIsWaitingForSave) {
        setTimeout(() => {
          setIsWaitingForSave(creditFunctions.isWaitingForSaveOfPortalField(personIndex, metafields));
        }, 2500);
      }


      if (portals && portals.length > 0) {
        getSignatures();
        Object.keys(signatureTemplates).forEach((key) => {
          getSetting(signatureTemplates[key]);
        })
      } else {
        getSuggestedPortalPin();
      }
    }
  }, [open]);

  useEffect(() => {
    if (open && portals && portals.length > 0) {
      getSignatures();
      Object.keys(signatureTemplates).forEach((key) => {
        getSetting(signatureTemplates[key]);
      })
      getExistingPortalPin();
    }
  }, [open, portals]);

  useEffect(() => {
    if (renderAs === "wizard") {
      setOpen(true);
    }
  }, []);

  const getSignatures = () => {
    let url = `${process.env.REACT_APP_API_SERVICE_URL}/signatures/${credit_id}`;
    const options = {
      url: url,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setSignatures(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getSuggestedPortalPin = () => {
    setIsLoadingPortalPin(true);
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/portals/pin/suggest`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setPortalPin(res.data.portal_pin || "");
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("PIN Vorschlag konnte nicht geladen werden.");
      })
      .finally(() => {
        setIsLoadingPortalPin(false);
      });
  }

  const getExistingPortalPin = () => {
    if (!portal || !portal.id) {
      return;
    }
    setIsLoadingPortalPin(true);
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/portals/${credit_id}/${portal.id}/pin`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setPortalPin(res.data.portal_pin || "");
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("PIN konnte nicht geladen werden.");
      })
      .finally(() => {
        setIsLoadingPortalPin(false);
      });
  };



  const createSignatureRequest = (document, callback) => {
    console.log("createSignatureRequest", document);
    setIsCreatingSignature(true);
    let filename = document.value.endsWith(".pdf") ? document.value : document.value + ".pdf";

    const data = {
      filename: filename,
      persons: [],
      common_document: document.common_document,
      setting_id: document.hasOwnProperty("id") ? parseInt(document.id) : 0,
      metafield_id: document.hasOwnProperty("metafield_id") ? parseInt(document.metafield_id) : 0,
    };
    if (document.kn1) data.persons.push(1);
    if (document.kn2) data.persons.push(2);
    if (document.kn3) data.persons.push(3);
    if (document.kn4) data.persons.push(4);

    let url = `${process.env.REACT_APP_API_SERVICE_URL}/signatures/${credit_id}`;
    const options = {
      url: url,
      data: data,
      method: 'post',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setIsCreatingSignature(false);
        getSignatures();
        if (callback)
          callback(res.data);

      })
      .catch((err) => {
        setIsCreatingSignature(false);
        if (err.response && err.response.data && err.response.data.message)
          pageContext.setErrorMessage(err.response.data.message);
        else
          pageContext.setErrorMessage("Die Unterschrift konnte nicht angelegt werden.");
        console.log(err.response.data.message);
      });
  }


  const getSetting = (signatureTemplate) => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${signatureTemplate.setting_type}/${signatureTemplate.key}`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then(({ data }) => {
        setSignatureTemplates(signatureTemplates => {
          return { ...signatureTemplates, [signatureTemplate.key]: { ...data, "kn1": personIndex === 1, "kn2": personIndex === 2, "kn3": personIndex === 3, "kn4": personIndex === 4, "common_document": false } };
        })
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message)
          pageContext.setErrorMessage(err.response.data.message);
        else
          pageContext.setErrorMessage("Die Einstellung konnte nicht geladen werden!");
      });
  }


  const maybeDeleteFile = (metafield) => {
    pageContext.setConfirmDialog({
      open: true,
      title: "Wirklich löschen?",
      message:
        "Bist du dir sicher, dass du die Datei " +
        metafield.file_document_type +
        " löschen möchtest?",
      handleYes: () => {
        const options = {
          url: `${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/${metafield.id}`,
          method: 'delete',
          headers: userContext.getRequestAuthHeader()
        };
        axios(options)
          .then((res) => {
            setMetafields(fields => {
              const index = fields.findIndex(field => field.id === metafield.id);
              if (index > -1) {
                fields[index].file_document_type = null;
                fields[index].meta_value = "";
                fields[index].meta_value_numeric = null;
              }

              return [...fields];
            })
          })
          .catch((err) => {
            console.log(err);
            pageContext.setErrorMessage("Datei konnte nicht gelöscht werden!");
          });

        pageContext.setConfirmDialog({
          open: false,
        });
      },
      handleNo: () => {
        pageContext.setConfirmDialog({
          open: false,
        });
      },
    });
  }


  const maybeDeletePortal = () => {
    pageContext.setConfirmDialog({
      open: true,
      title: "Wirklich löschen?",
      message:
        "Bist du dir sicher, dass du das Kundenportal löschen möchtest?",
      handleYes: () => {
        const options = {
          url: `${process.env.REACT_APP_API_SERVICE_URL}/portals/${credit_id}/${portal.id}`,
          method: 'delete',
          headers: userContext.getRequestAuthHeader()
        };
        axios(options)
          .then((res) => {
            setOpen(false);
            window.location.reload()
          })
          .catch((err) => {
            console.log(err);
            pageContext.setErrorMessage("Portal konnte nicht gelöscht werden!");
          });

        pageContext.setConfirmDialog({
          open: false,
        });
      },
      handleNo: () => {
        pageContext.setConfirmDialog({
          open: false,
        });
      },
    });
  }


  const maybeCancelSignature = (signature) => {
    pageContext.setConfirmDialog({
      open: true,
      title: "Wirklich abbrechen?",
      message:
        "Bist du dir sicher, dass du die Unterschriftanfrage abbrechen möchtest?",
      handleYes: () => {
        const options = {
          url: `${process.env.REACT_APP_API_SERVICE_URL}/signatures/${signature.id}`,
          method: 'delete',
          headers: userContext.getRequestAuthHeader()
        };
        axios(options)
          .then((res) => {
            getSignatures()
          })
          .catch((err) => {
            console.log(err);
            pageContext.setErrorMessage("Unterschrift konnte nicht gelöscht werden!");
          });

        pageContext.setConfirmDialog({
          open: false,
        });
      },
      handleNo: () => {
        pageContext.setConfirmDialog({
          open: false,
        });
      },
    });
  }


  const renderUpload = () => {
    const nextFreeField = metafields
      .find(field => field.meta_key.startsWith("signature_file") && !field.meta_value)
    if (!nextFreeField)
      return <Alert severity="info">Du kannst nur 20 Dokumente pro Finanzierung hochladen.</Alert>

    return <FileUploadField
      setMetafields={setMetafields}
      metafield_prop={nextFreeField}
      allowMultiple={false}
      allowImages={false}
      description={
        <>
          Lade ein PDF Dokument zum Unterschreiben hoch. <br />
          Darin kannst du folgende Platzhalter verwenden:
          <ul>
            <li><strong>[NAME]</strong>... fügt den Vor- und Nachnamen des aktuellen Kreditnehmers ein.</li>
            <li><strong>[NAME KN1], [NAME KN2]</strong>... fügt den Namen eines bestimmten Kreditnehmers ein.</li>
            <li><strong>[NAMEN]</strong>... fügt die Namen aller Kreditnehmer ein.</li>
            <li><strong>[NAME BERATER]</strong>... fügt deinen Namen ein.</li>
            <li><strong>[ALLE BERATER]</strong>... fügt deinen Namen sowie die Geschäftsführer ein.</li>
            <li><strong>[ADRESSE]</strong>... fügt die Adresse des aktuellen Kreditnehmers ein.</li>
            <li><strong>[ADRESSE KN1], [ADRESSE KN2]</strong>... fügt die Adresse eines bestimmten Kreditnehmers ein.</li>
            <li><strong>[DATUM]</strong>... fügt das aktuelle Datum ein.</li>
          </ul>
        </>
      }

    />
  }

  const renderContent = () => {
    return (<><Typography variant="body1">Im Kundenportal können die Kreditnehmer selbst ihre persönlichen Daten ausfüllen und Dokumente unterzeichnen.</Typography>
      {hasAllRequiredFields && portal && portal.url &&
        <Grid container spacing={4} alignItems="center">
          <Grid item>
            <CopyToClipboard
              text={portal.url}
              onCopy={() => pageContext.setInfoMessage("Ich habe den Link in deine Zwischenablage kopiert.")}>
              <Button size="small">Portal-Link kopieren</Button>
            </CopyToClipboard>
          </Grid>
          {portal && portal.url && portalPin && (
            <Grid item>
              <Typography variant="body2">
                Kundenportal PIN: <strong>{portalPin}</strong>
              </Typography>
            </Grid>
          )}
        </Grid>
      }

      <br /><br />
      {!hasAllRequiredFields &&
        <Alert severity="warning">Bitte fülle zuerst Anrede, Name, E-Mail, Mobilnummer und Adresse aus.</Alert>
      }
      {isWaitingForSave &&
        <Alert severity="warning">Deine Eingaben werden gerade noch gespeichert. Einen Moment noch...</Alert>
      }
      {!portal && !isWaitingForSave && hasAllRequiredFields &&
        <>
          <Typography variant="h5">Kundenportal PIN</Typography>
          <Typography variant="body2">Der Kunde muss diese 4-stellige PIN beim Öffnen des Kundenportals eingeben.</Typography>
          <br />
          <TextField
            label="4-stellige PIN"
            value={portalPin}
            onChange={(e) => {
              const nextPin = (e.target.value || "").replace(/\D/g, "").slice(0, 4);
              setPortalPin(nextPin);
            }}
            helperText={isLoadingPortalPin ? "PIN Vorschlag wird geladen..." : "Nur Zahlen, genau 4 Stellen"}
            inputProps={{ maxLength: 4 }}
          />
          <Button
            size="small"
            disabled={isLoadingPortalPin}
            onClick={() => {
              getSuggestedPortalPin();
            }}
          >
            neue PIN vorschlagen
          </Button>
          <br /><br />
        </>
      }
      {portal &&
        <>
          <Typography variant="h5">Eingabe der Kundendaten</Typography>
          {portal.status === "draft" &&
            <Alert
              severity="error"
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    maybeDeletePortal()
                  }}
                >
                  löschen
                </Button>
              }
            >Ich konnte den Portal Link nicht an {creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__email")} senden. </Alert>
          }
          {portal.status === "open" &&
            <Alert severity="success">{creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname") + " " +
              creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname")} hat bis {formatDateTime(portal.fields_enabled_until)} Zugriff auf die Eingabefelder im Kundenportal. <br />
              Unterschriften bleiben unbeschränkt verfügbar.</Alert>
          }
          {portal.status === "fields_expired" &&
            <Alert
              severity="info"
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    const newPortal = {
                      id: portal.id,
                    };
                    newPortal.fields_enabled_until = new Date();
                    newPortal.fields_enabled_until.setUTCHours(24, 0, 0, 0); // next midnight
                    newPortal.fields_enabled_until.setDate(newPortal.fields_enabled_until.getDate() + 1);
                    newPortal.status = "open"
                    savePortal(newPortal, () => {
                      pageContext.setInfoMessage("Der Zugang zu den Kundendaten im Portal für "
                        + creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname")
                        + " " + creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname")
                        + " wurde bis morgen Abend verlängert.");
                    });
                    setOpen(false);
                  }}
                >
                  verlängern
                </Button>
              }
            >
              Der Portal-Zugriff auf die Eingabefelder für {creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname") + " " +
                creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname")} ist am {formatDateTime(portal.fields_enabled_until)} abgelaufen.<br />
              Der Zugriff auf die Unterschriften bleiben unbeschränkt verfügbar.
            </Alert>
          }
          {portal.status === "fields_done" &&
            <Alert
              severity="success"
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    const newPortal = {
                      id: portal.id,
                    };
                    newPortal.fields_enabled_until = new Date();
                    newPortal.fields_enabled_until.setUTCHours(24, 0, 0, 0); // next midnight
                    newPortal.fields_enabled_until.setDate(newPortal.fields_enabled_until.getDate() + 1);
                    newPortal.status = "open"
                    savePortal(newPortal, () => {
                      pageContext.setInfoMessage("Der Zugang zum Kundenportal für "
                        + creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname")
                        + " " + creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname")
                        + " wurde bis morgen Abend verlängert.");
                    });
                    setOpen(false);
                  }}
                >
                  nochmal öffnen
                </Button>
              }
            >
              {creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname") + " " +
                creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname")} hat die Daten ausgefüllt und abgeschickt.
            </Alert>
          }


          {["administrator", "agent"].includes(userContext.user.role) &&
            <>
              <br />
              <br />
              <Typography variant="h5">Unterschriften</Typography>
              {portals.length === 1 && renderAs === "dialog" &&
                <Alert severity="info">Um Unterschriften von weiteren Kreditnehmern einzuholen leg bitte zuerst das Kundenportal für die jeweiligen Kreditnehmer an.</Alert>
              }
              <List>
                <Divider />
                {!signatures || signatures.length === 0 &&
                  <Alert severity="info">Wähle unten ein Dokument, das du zum Unterschreiben an die Kreditnehmer sendest.</Alert>
                }
                {signatures && signatures.length
                  ? signatures.filter(signature => signature.portal_id === portal.id).map(signature => {
                    return (
                      <div key={signature.id}>
                        <ListItem>
                          <ListItemIcon>
                            <SvgIcon>
                              <path fill="currentColor" d="M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M18.96 7.33L13.29 13H11V10.71L16.67 5.03L18.96 7.33M22.36 6.55C22.35 6.85 22.04 7.16 21.72 7.47L19.2 10L18.33 9.13L20.93 6.54L20.34 5.95L19.67 6.62L17.38 4.33L19.53 2.18C19.77 1.94 20.16 1.94 20.39 2.18L21.82 3.61C22.06 3.83 22.06 4.23 21.82 4.47C21.61 4.68 21.41 4.88 21.41 5.08C21.39 5.28 21.59 5.5 21.79 5.67C22.08 5.97 22.37 6.25 22.36 6.55Z" />
                            </SvgIcon>
                          </ListItemIcon>
                          <ListItemText primary={signature.title} />
                          <ListItemSecondaryAction>
                            {signature.status === "open"
                              && <Chip
                                size="small"
                                label="Warte auf Unterschrift"
                                icon={<HourglassEmptyIcon />}
                              />}
                            {signature.status === "closed"
                              &&
                              <Chip
                                size="small"
                                label="Fertig unterschrieben"
                                color="secondary"
                                icon={<CheckCircleIcon />}
                              />
                            }



                            {/* <Tooltip title="Download">
                              <IconButton
                                edge="end"
                                aria-label="download"
                                download target="_blank"
                                href={`${process.env.REACT_APP_API_SERVICE_URL}/signatures/${credit_id}/${signature.id}?token=${userContext.accessToken}`}
                              >
                                <GetAppIcon />
                              </IconButton>
                            </Tooltip> */}
                            <Tooltip title="Abbrechen">
                              <IconButton
                                edge="end"
                                aria-label="löschen"
                                onClick={() => {
                                  maybeCancelSignature(signature)
                                }}
                              >
                                <CancelIcon />
                              </IconButton>
                            </Tooltip>

                          </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                      </div>
                    )
                  }
                  )
                  : <></>
                }
              </List>
              <br /><br />

              <Typography variant="h6">Neue Unterschrift aus Vorlage anfordern:</Typography>
              <List>
                <Divider />
                {Object.keys(signatureTemplates).map(key => {
                  if (!signatureTemplates[key].value)
                    return null;
                  return (
                    <div key={key}>
                      <ListItem>
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary={signatureTemplates[key].value} />
                        <ListItemSecondaryAction>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              console.log(signatureTemplates[key]);
                              setRequestSignatureDocument(signatureTemplates[key]);
                            }}
                          >
                            Unterschrift anfordern
                          </Button>

                          <Tooltip title="Download">
                            <IconButton
                              edge="end"
                              aria-label="download"
                              download target="_blank"
                              href={`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/${key}/${signatureTemplates[key].value}?token=${userContext.accessToken}`}
                            >
                              <GetAppIcon />
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider />
                    </div>
                  )
                }
                )}
              </List>
              <br /><br />
              <Typography variant="h6">Eigene Dokumente:</Typography>
              <List>
                <Divider />
                {metafields
                  .filter(field => {
                    if (field.meta_key.startsWith("signature_file")) {
                      return true;
                    }
                    return false;
                  })
                  .map(field => {
                    if (!field.meta_value)
                      return null;
                    return (
                      <div key={field.meta_key}>
                        <ListItem>
                          <ListItemIcon>
                            <DescriptionIcon />
                          </ListItemIcon>
                          <ListItemText primary={field.file_document_type} />
                          <ListItemSecondaryAction>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                setRequestSignatureDocument({
                                  metafield_id: field.id,
                                  value: field.file_document_type,
                                  kn1: personIndex === 1,
                                  kn2: personIndex === 2,
                                  kn3: personIndex === 3,
                                  kn4: personIndex === 4,
                                  common_document: false
                                });
                              }}
                            >
                              Unterschrift anfordern
                            </Button>
                            {/* <IconButton
                            edge="end"
                            download target="_blank"
                            href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/${field.id}/${field.file_document_type}?token=${userContext.accessToken}`}>
                            <GetAppIcon/>
                          </IconButton> */}
                            <Tooltip title="Datei löschen">
                              <IconButton
                                edge="end"
                                aria-label="löschen"
                                onClick={() => {
                                  maybeDeleteFile(field)
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                      </div>
                    );
                  }
                  )}

                {Object.keys(signatureTemplates).map(key => {
                  if (!signatureTemplates[key].value)
                    return null;
                  return (
                    <div key={key}>

                    </div>
                  )
                }
                )}
                {renderUpload()}
              </List>
            </>}

        </>
      }</>);
  };

  const renderActions = () => {
    if (portal)
      return <> </>;

    return <Button
      disabled={!hasAllRequiredFields || isWaitingForSave}
      onClick={() => {
        if (!portal) {
          if (!/^\d{4}$/.test(portalPin)) {
            pageContext.setErrorMessage("Bitte gib eine 4-stellige numerische PIN ein.");
            return;
          }
          createPortal(personIndex, portalPin, () => {
            pageContext.setInfoMessage("Der Zugang zum Kundenportal wurde an "
              + creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__vorname")
              + " " + creditFunctions.getFirstValueByMetaKey("__person" + personIndex + "__nachname")
              + " gesendet und ist jetzt drei Tage lang gültig.");
          });
        }
      }}
      color="primary"
      variant="contained"
      autoFocus>
      Link an Kreditnehmer senden
    </Button>
  }

  const renderSignatureDialog = () => {
    return (<Dialog
      onClose={() => { setRequestSignatureDocument(false) }}
      open={Boolean(requestSignatureDocument)}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle>Unterschrift anfordern</DialogTitle>
      {isCreatingSignature && (
        <LinearProgress />
      )}
      {requestSignatureDocument && !requestSignatureDocument.hasOwnProperty('viewer_urls') &&
        <DialogContent>
          <DialogContentText>Sende das Dokument {requestSignatureDocument.value} an die Kreditnehmer zur Unterschrift.</DialogContentText>
          {[1, 2, 3, 4].map(i =>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isCreatingSignature || portals.find((portal) => portal.person_index == i) === undefined}
                  checked={requestSignatureDocument['kn' + i]}
                  onChange={(e) => {
                    setRequestSignatureDocument(doc => {
                      doc['kn' + i] = e.target.checked;
                      return { ...doc };
                    })
                  }}

                />
              }
              key={requestSignatureDocument.key + "_kn" + i}
              label={"Kreditnehmer " + i}
            />
          )}
          <br /><br />
          <RadioGroup
            value={requestSignatureDocument['common_document']}
            onChange={(e) => {

              setRequestSignatureDocument(doc => {
                console.log(doc);
                doc['common_document'] = e.target.value === true || e.target.value === "true";
                return { ...doc };
              })
            }}>
            <FormControlLabel
              value={false}
              control={<Radio />}
              label="Jeder Kreditnehmer erhält eine eigene Kopie des Dokuments"
              disabled={
                isCreatingSignature ||
                (
                  (requestSignatureDocument['kn1'] ? 1 : 0)
                  + (requestSignatureDocument['kn2'] ? 1 : 0)
                  + (requestSignatureDocument['kn3'] ? 1 : 0)
                  + (requestSignatureDocument['kn4'] ? 1 : 0)
                  < 2
                )
              }
            />
            <FormHelperText>Es reicht ein Unterschriftenfeld, das jeder Kreditnehmer in seinem eigenen Dokument unterzeichnet.</FormHelperText>
            <FormControlLabel
              value={true}
              control={<Radio />}
              label="Alle Kreditnehmer unterschreiben im selben Dokument"
              disabled={
                isCreatingSignature ||
                (
                  (requestSignatureDocument['kn1'] ? 1 : 0)
                  + (requestSignatureDocument['kn2'] ? 1 : 0)
                  + (requestSignatureDocument['kn3'] ? 1 : 0)
                  + (requestSignatureDocument['kn4'] ? 1 : 0)
                  < 2
                )
              }
            />
            <FormHelperText>In diesem Fall müssen auch genug Unterschriftsfelder für alle Kreditnehmer vorhanden sein.</FormHelperText>
          </RadioGroup>
        </DialogContent>
      }
      {requestSignatureDocument && requestSignatureDocument.hasOwnProperty('viewer_urls') &&
        <DialogContent>
          <DialogContentText>Füge jetzt noch die Felder für die Unterschriften ein:</DialogContentText>
          {
            requestSignatureDocument.viewer_urls.map(viewer =>
              <Button color="primary" variant="contained" className={classes.addFieldsButton} key={viewer.person_index} href={viewer.url} target="_blank">
                Felder {viewer.person_index > -1 ? "für KN" + viewer.person_index : ""} einfügen
              </Button>)
          }
          <br /><br />
          <DialogContentText>...und klick dann auf "Fertig"</DialogContentText>
        </DialogContent>
      }
      {
        requestSignatureDocument.hasOwnProperty('viewer_urls')
          ? <DialogActions>
            <Button onClick={() => { setRequestSignatureDocument(false) }} color="primary">
              Fertig
            </Button>
          </DialogActions>
          : <DialogActions>
            <Button
              onClick={() => { setRequestSignatureDocument(false) }}
              disabled={isCreatingSignature}
              color="primary">
              abbrechen
            </Button>
            <Button
              color="primary"
              variant="contained"
              disabled={
                isCreatingSignature ||
                (
                  !requestSignatureDocument['kn1']
                  && !requestSignatureDocument['kn2']
                  && !requestSignatureDocument['kn3']
                  && !requestSignatureDocument['kn4']
                )
              }
              onClick={() => {
                createSignatureRequest(requestSignatureDocument, (viewer_urls) => {
                  console.log(viewer_urls);
                  pageContext.setInfoMessage("Das Dokument wurde angelegt und steht den Kreditnehmern jetzt im Kundenportal zur Verfügung.");
                  setRequestSignatureDocument(requestSignatureDocument => { return { ...requestSignatureDocument, viewer_urls: viewer_urls }; });
                });
              }}
            >
              Dokument senden
            </Button>
          </DialogActions>
      }
    </Dialog>);
  }
  const portal = portals.find((portal) => portal.person_index == personIndex);


  if (renderAs === "wizard") {
    return (
      <>
        {renderContent()}
        <br />
        {renderActions()}
        {renderSignatureDialog()}
      </>

    );
  }

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<ContactMailIcon />}
        onClick={() => {
          setOpen(true);
        }}
      >
        KundenPortal
      </Button>
      <InfoTooltip
        content="Erstelle ein Kundenportal zum Ausfüllen der persönlichen Daten und zum Unterschreiben von Dokumenten."
      />
      <Dialog
        onClose={() => { setOpen(false) }}
        open={open}
        fullWidth={true}
        maxWidth="md">
        <DialogTitle>
          KundenPortal
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {renderContent()}
          <DialogContentText>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {renderActions()}
        </DialogActions>
      </Dialog>
      {renderSignatureDialog()}
    </>
  );
}
